import React from 'react';
import { motion } from 'framer-motion';
import CTAButton from '../CTAButton';

const ServiceDifferentiators = ({ title, differentiators, onCtaClick }) => {
    return (
        <section className="py-24 bg-white">
            <div className="container mx-auto px-6">
                <div className=" mx-auto text-center mb-16">
                    <h2 className="text-3xl md:text-5xl font-bold text-slate-900 syne mb-4">
                        {title || "Why Choose Merida HR"}
                    </h2>
                    <p className="text-slate-500 text-sm md:text-base leading-relaxed">
                        Discover the strategic advantages and operational differences that set our services apart.
                    </p>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {differentiators.map((diff, i) => (
                        <motion.div 
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: i * 0.1 }}
                            key={i} 
                            className="bg-blue-50/20 p-8 rounded-[2rem] border border-blue-100/50 shadow-sm hover:shadow-xl transition-all group"
                        >
                            <div className="w-12 h-12 bg-[#01014C] rounded-xl flex items-center justify-center text-white font-black mb-6 group-hover:bg-blue-600 transition-colors">
                                0{i + 1}
                            </div>
                            <h4 className="text-xl font-bold text-slate-900 mb-4">{diff.title}</h4>
                            <p className="text-sm text-slate-900 leading-relaxed">{diff.description}</p>
                        </motion.div>
                    ))}

                    {/* Filler Card for unbalanced grids */}
                    {differentiators.length % 3 !== 0 && (
                        <motion.div 
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: differentiators.length * 0.1 }}
                            className={`bg-gradient-to-br from-[#01014C] to-blue-900 p-8 rounded-[2rem] border border-blue-800 shadow-xl flex flex-col justify-center items-center text-center group col-span-1 ${
                                differentiators.length % 2 === 0 ? 'md:col-span-2' : 'md:col-span-1'
                            } ${
                                differentiators.length % 3 === 1 ? 'lg:col-span-2' : 'lg:col-span-1'
                            }`}
                        >
                            <h4 className="text-2xl font-bold text-white mb-4">Ready to Scale Your Team?</h4>
                            <p className="text-blue-200 text-sm mb-8 max-w-sm">Connect with our strategic consultants to build compliant, efficient, and robust workforce operations.</p>
                            {onCtaClick && (
                                <button 
                                    onClick={onCtaClick}
                                    className="px-6 py-3.5 bg-white text-[#01014C] font-bold rounded-xl hover:bg-blue-50 transition-all hover:scale-105 active:scale-95 text-sm shadow-lg w-full max-w-xs"
                                >
                                    Discuss Your Requirements
                                </button>
                            )}
                        </motion.div>
                    )}
                </div>

                {/* Only show the bottom centered CTA if the grid is perfectly filled (no filler card) */}
                {onCtaClick && differentiators.length % 3 === 0 && (
                    <div className="mt-16 text-center flex justify-center">
                        <CTAButton text="Discover The Merida Advantage" onClick={onCtaClick} />
                    </div>
                )}
            </div>
        </section>
    );
};

export default ServiceDifferentiators;
